<template>
  <div class="main-page-container">
    <b-modal id="addIntegration" scrollable hide-footer hide-header size="lg">
      <AddIntegModal />
    </b-modal>

    <b-modal id="wondeFlow" scrollable hide-footer hide-header size="lg">
      <WondeHaveTokenModal />
    </b-modal>

    <b-modal id="extraScenario" scrollable hide-footer hide-header size="lg">
      <AddIntegModalExtraScenario />
    </b-modal>

    <b-modal id="noGroups" scrollable hide-footer hide-header size="md">
      <NoGroupsModal />
    </b-modal>
    <!-- header -->
    <AlertFoundActiveSession />
    <PageHeader
      :title="$t('integrations.addIntegration')"
      className="d-flex align-items-center justify-content-between"
    />
    <section>
      <b-row>
        <b-col
          cols="6"
          class="int-cards"
          v-for="(card, index) in getDirectoryList"
          :key="index"
        >
          <b-card>
            <b-row class="flex-grow-1">
              <b-col
                cols="2"
                class="d-flex align-items-center img-customization"
              >
                <img
                  :src="require('@/assets/images/' + card.img_url)"
                  alt="directory img"
                  class="img-fluid"
                />
              </b-col>
              <b-col
                cols="8"
                class="text-left d-flex flex-column align-items-start"
              >
                <h4 class="card-head">{{ card.name }}</h4>
                <p class="card-text">{{ card.description }}</p>
              </b-col>
              <b-col cols="2" class="d-flex card-icon align-items-center">
                <div
                  v-if="card.code == 'googleAD'"
                  class="card-circle"
                  @click="setDataAndReAuth(card)"
                  style="cursor: pointer"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.2158 3.98251C21.3137 2.08075 18.8904 0.785715 16.2523 0.261151C13.6143 -0.263414 10.8799 0.0060519 8.39495 1.03547C5.91002 2.0649 3.78613 3.80804 2.29185 6.0445C0.797566 8.28096 0 10.9103 0 13.6C0 16.2897 0.797566 18.9191 2.29185 21.1555C3.78613 23.392 5.91002 25.1351 8.39495 26.1645C10.8799 27.194 13.6143 27.4634 16.2523 26.9389C18.8904 26.4143 21.3137 25.1193 23.2158 23.2175C25.7651 20.666 27.1971 17.2068 27.1971 13.6C27.1971 9.99321 25.7651 6.53398 23.2158 3.98251ZM21.4548 14.5825C21.1875 14.8449 20.8293 14.9942 20.4548 14.9995H15.0328V20.4215C15.0312 20.7971 14.8813 21.1569 14.6157 21.4224C14.3502 21.688 13.9904 21.8379 13.6148 21.8395C13.4281 21.8411 13.243 21.8055 13.0703 21.7348C12.8975 21.6641 12.7406 21.5597 12.6086 21.4278C12.4766 21.2958 12.3722 21.1388 12.3015 20.966C12.2308 20.7933 12.1952 20.6082 12.1968 20.4215V15.0015H6.77581C6.58959 15.0015 6.4052 14.9648 6.23316 14.8936C6.06112 14.8223 5.9048 14.7179 5.77313 14.5862C5.64145 14.4545 5.537 14.2982 5.46574 14.1262C5.39448 13.9541 5.3578 13.7697 5.3578 13.5835C5.3578 13.3973 5.39448 13.2129 5.46574 13.0409C5.537 12.8688 5.64145 12.7125 5.77313 12.5808C5.9048 12.4492 6.06112 12.3447 6.23316 12.2734C6.4052 12.2022 6.58959 12.1655 6.77581 12.1655H12.1978V6.74451C12.1962 6.55785 12.2318 6.37274 12.3025 6.19997C12.3732 6.02721 12.4776 5.87026 12.6096 5.73826C12.7416 5.60627 12.8985 5.50188 13.0713 5.43119C13.244 5.36049 13.4291 5.32491 13.6158 5.32651C13.8025 5.32491 13.9876 5.36049 14.1603 5.43119C14.3331 5.50188 14.4901 5.60627 14.622 5.73826C14.754 5.87026 14.8584 6.02721 14.9291 6.19997C14.9998 6.37274 15.0354 6.55785 15.0338 6.74451V12.1665H20.4558C20.6425 12.1649 20.8276 12.2005 21.0003 12.2712C21.1731 12.3419 21.3301 12.4463 21.4621 12.5783C21.594 12.7103 21.6984 12.8672 21.7691 13.04C21.8398 13.2127 21.8754 13.3978 21.8738 13.5845C21.8492 13.9553 21.7022 14.3074 21.4558 14.5855L21.4548 14.5825Z"
                      fill="#103F5E"
                    />
                  </svg>
                </div>

                <div
                  v-else-if="card.code == 'wonde'"
                  class="card-circle"
                  v-b-modal="'wondeFlow'"
                  @click="setDataAndReAuth(card)"
                  style="cursor: pointer"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.2158 3.98251C21.3137 2.08075 18.8904 0.785715 16.2523 0.261151C13.6143 -0.263414 10.8799 0.0060519 8.39495 1.03547C5.91002 2.0649 3.78613 3.80804 2.29185 6.0445C0.797566 8.28096 0 10.9103 0 13.6C0 16.2897 0.797566 18.9191 2.29185 21.1555C3.78613 23.392 5.91002 25.1351 8.39495 26.1645C10.8799 27.194 13.6143 27.4634 16.2523 26.9389C18.8904 26.4143 21.3137 25.1193 23.2158 23.2175C25.7651 20.666 27.1971 17.2068 27.1971 13.6C27.1971 9.99321 25.7651 6.53398 23.2158 3.98251ZM21.4548 14.5825C21.1875 14.8449 20.8293 14.9942 20.4548 14.9995H15.0328V20.4215C15.0312 20.7971 14.8813 21.1569 14.6157 21.4224C14.3502 21.688 13.9904 21.8379 13.6148 21.8395C13.4281 21.8411 13.243 21.8055 13.0703 21.7348C12.8975 21.6641 12.7406 21.5597 12.6086 21.4278C12.4766 21.2958 12.3722 21.1388 12.3015 20.966C12.2308 20.7933 12.1952 20.6082 12.1968 20.4215V15.0015H6.77581C6.58959 15.0015 6.4052 14.9648 6.23316 14.8936C6.06112 14.8223 5.9048 14.7179 5.77313 14.5862C5.64145 14.4545 5.537 14.2982 5.46574 14.1262C5.39448 13.9541 5.3578 13.7697 5.3578 13.5835C5.3578 13.3973 5.39448 13.2129 5.46574 13.0409C5.537 12.8688 5.64145 12.7125 5.77313 12.5808C5.9048 12.4492 6.06112 12.3447 6.23316 12.2734C6.4052 12.2022 6.58959 12.1655 6.77581 12.1655H12.1978V6.74451C12.1962 6.55785 12.2318 6.37274 12.3025 6.19997C12.3732 6.02721 12.4776 5.87026 12.6096 5.73826C12.7416 5.60627 12.8985 5.50188 13.0713 5.43119C13.244 5.36049 13.4291 5.32491 13.6158 5.32651C13.8025 5.32491 13.9876 5.36049 14.1603 5.43119C14.3331 5.50188 14.4901 5.60627 14.622 5.73826C14.754 5.87026 14.8584 6.02721 14.9291 6.19997C14.9998 6.37274 15.0354 6.55785 15.0338 6.74451V12.1665H20.4558C20.6425 12.1649 20.8276 12.2005 21.0003 12.2712C21.1731 12.3419 21.3301 12.4463 21.4621 12.5783C21.594 12.7103 21.6984 12.8672 21.7691 13.04C21.8398 13.2127 21.8754 13.3978 21.8738 13.5845C21.8492 13.9553 21.7022 14.3074 21.4558 14.5855L21.4548 14.5825Z"
                      fill="#103F5E"
                    />
                  </svg>
                </div>

                <div
                  v-else
                  class="card-circle"
                  v-b-modal="'addIntegration'"
                  @click="setDataAndReAuth(card)"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.2158 3.98251C21.3137 2.08075 18.8904 0.785715 16.2523 0.261151C13.6143 -0.263414 10.8799 0.0060519 8.39495 1.03547C5.91002 2.0649 3.78613 3.80804 2.29185 6.0445C0.797566 8.28096 0 10.9103 0 13.6C0 16.2897 0.797566 18.9191 2.29185 21.1555C3.78613 23.392 5.91002 25.1351 8.39495 26.1645C10.8799 27.194 13.6143 27.4634 16.2523 26.9389C18.8904 26.4143 21.3137 25.1193 23.2158 23.2175C25.7651 20.666 27.1971 17.2068 27.1971 13.6C27.1971 9.99321 25.7651 6.53398 23.2158 3.98251ZM21.4548 14.5825C21.1875 14.8449 20.8293 14.9942 20.4548 14.9995H15.0328V20.4215C15.0312 20.7971 14.8813 21.1569 14.6157 21.4224C14.3502 21.688 13.9904 21.8379 13.6148 21.8395C13.4281 21.8411 13.243 21.8055 13.0703 21.7348C12.8975 21.6641 12.7406 21.5597 12.6086 21.4278C12.4766 21.2958 12.3722 21.1388 12.3015 20.966C12.2308 20.7933 12.1952 20.6082 12.1968 20.4215V15.0015H6.77581C6.58959 15.0015 6.4052 14.9648 6.23316 14.8936C6.06112 14.8223 5.9048 14.7179 5.77313 14.5862C5.64145 14.4545 5.537 14.2982 5.46574 14.1262C5.39448 13.9541 5.3578 13.7697 5.3578 13.5835C5.3578 13.3973 5.39448 13.2129 5.46574 13.0409C5.537 12.8688 5.64145 12.7125 5.77313 12.5808C5.9048 12.4492 6.06112 12.3447 6.23316 12.2734C6.4052 12.2022 6.58959 12.1655 6.77581 12.1655H12.1978V6.74451C12.1962 6.55785 12.2318 6.37274 12.3025 6.19997C12.3732 6.02721 12.4776 5.87026 12.6096 5.73826C12.7416 5.60627 12.8985 5.50188 13.0713 5.43119C13.244 5.36049 13.4291 5.32491 13.6158 5.32651C13.8025 5.32491 13.9876 5.36049 14.1603 5.43119C14.3331 5.50188 14.4901 5.60627 14.622 5.73826C14.754 5.87026 14.8584 6.02721 14.9291 6.19997C14.9998 6.37274 15.0354 6.55785 15.0338 6.74451V12.1665H20.4558C20.6425 12.1649 20.8276 12.2005 21.0003 12.2712C21.1731 12.3419 21.3301 12.4463 21.4621 12.5783C21.594 12.7103 21.6984 12.8672 21.7691 13.04C21.8398 13.2127 21.8754 13.3978 21.8738 13.5845C21.8492 13.9553 21.7022 14.3074 21.4558 14.5855L21.4548 14.5825Z"
                      fill="#103F5E"
                    />
                  </svg>
                </div>

                <!-- <i
                  v-b-modal="'addIntegration'"
                  class="mdi mdi-plus-circle"
                  @click="setDataAndReAuth(card)"
                ></i> -->
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <hr class="mt-1" />
    <PageHeader className="d-flex align-items-center " :title="title" />
    <section class="integration-white-bg-sec integration-table">
      <!-- <div><h5 class="int-grid">Available Integrations</h5></div> -->
      <DxDataGrid
        id="allIntgContainer"
        :data-source="integrationsArr"
        :ref="dataGridRefName"
        :remote-operations="false"
        :showBorders="false"
        :columnAutoWidth="true"
        :allowColumnReordering="true"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :showColumnLines="true"
        :showRowLines="true"
        :repaint-changes-only="true"
        :two-way-binding-enabled="true"
        :no-data-text="$t('common.grid.noDataYet')"
        @row-updated="updateRow($event)"
        @content-ready="contentReady($event)"
        @editor-preparing="onEditorPreparing($event)"
        @data-error-occurred="onDataErrorOccurred($event)"
        :rtl-enabled="rtlEnabled"
      >
        <DxStateStoring
          :enabled="true"
          type="custom"
          :customSave="customSave"
          :customLoad="customLoad"
        />
        <!-- <DxEditing :use-icons="true" :allow-updating="true" :allow-adding="false" :allow-deleting="false" mode="row" /> -->
        <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
        <DxPaging :page-size="0" :visible="integrationsArr.length > 0" />
        <DxPager
          :visible="integrationsArr.length > 0"
          :allowed-page-sizes="[5, 10, 25, 50, 100, 0]"
          :display-mode="'full'"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
          :infoText="rtlEnabled ?  'صفحة {0} من {1} ({2} إجمالي العناصر)' : ''"
        />

        <!-- <DxSelection mode="multiple"/> -->

        <DxFilterRow :visible="true" />
        <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter"/> -->

        <DxHeaderFilter :visible="true" />

        <!-- <DxSearchPanel :visible="true" placeholder="Search..." /> -->

        <DxColumnChooser
          :enabled="true"
          mode="select"
          :title="$t('common.grid.columnChooser')"
        />

        <DxExport :enabled="true" :allow-export-selected-data="false" />

        <DxToolbar>
          <!-- <DxItem name="columnChooserButton" location="before" /> -->
          <DxItem location="before" template="columnButtonTemplate" />
          <DxItem template="exportButtonTemplate" location="before" />
          <DxItem template="clearAllTemplate" location="before" />
        </DxToolbar>

        <DxGrouping :context-menu-enabled="true" />
        <DxGroupPanel :visible="true" />

        <DxColumn
          data-field="integrationName"
          :caption="$t('integrations.grid.integrationName')"
          :allow-header-filtering="false"
          :allow-editing="false"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
        />

        <DxColumn
          data-field="type"
          :caption="$t('integrations.grid.integrationType')"
          :allow-header-filtering="true"
          :allow-editing="false"
          :allow-filtering="false"
          :filter-operations="allowedOperations"
        />

        <DxColumn
          :filter-operations="allowedOperations"
          :caption="$t('common.status')"
          :allow-header-filtering="true"
          :allow-editing="false"
          :allow-filtering="false"
          data-field="status"
          :calculate-cell-value="getStatus"
          cell-template="status-cell"
        />

        <DxColumn
          :filter-operations="allowedOperations"
          :caption="$t('common.errors')"
          :allow-header-filtering="true"
          :allow-editing="false"
          :allow-filtering="false"
          data-field="errors"
          alignment="left"
        />

        <DxColumn
          :filter-operations="allowedOperations"
          :allow-header-filtering="true"
          :allow-editing="false"
          :allow-filtering="false"
          data-field="duplicates"
          :caption="$t('common.duplicates')"
          alignment="left"
        />

        <DxColumn
          data-field="syncPeriod"
          :caption="$t('integrations.grid.syncPeriod')"
          :allow-header-filtering="true"
          :allow-editing="false"
          :allow-filtering="false"
          :filter-operations="allowedOperations"
        />

        <DxColumn
          data-field="creationDate"
          :caption="$t('common.creationDate')"
          :visible="true"
          :allow-header-filtering="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
          :allow-editing="false"
        />

        <DxColumn
          data-field="lastSynced"
          :caption="$t('integrations.grid.lastSynced')"
          :visible="true"
          :allow-header-filtering="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
          :allow-editing="false"
        />

        <DxColumn
          data-field="site"
          :allow-header-filtering="true"
          :allow-editing="false"
          :allow-filtering="false"
          :filter-operations="allowedOperations"
          :caption="$t('common.site')"
          :calculate-cell-value="getSites"
        />

        <DxColumn
          :caption="$t('common.grid.actions')"
          id="custom-ActionDropDown"
          cell-template="action-cell"
          :allow-filtering="false"
          :allow-exporting="false"
          :allow-editing="false"
          :allow-header-filtering="false"
          :min-width="200"
          css-class="select-actions custom-ActionDropDown"
        />

        <!-- <template #site-cell="{ data }">
          <div>
            <div
              class="error-value"
              v-for="(key, index) of data.data.requiredError"
              :key="index"
            >
              {{ key }} is required.
            </div>
          </div>
        </template> -->

        <template #clearAllTemplate>
          <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
            <div class="toolbar-custom-line"></div>
            <Button
              :text="$t('common.grid.clearFilters')"
              @click="clearFilter"
              styling-mode="outlined"
              type="danger"
              class="clear-CustomColums"
            />
          </div>
        </template>
        <template #exportButtonTemplate>
          <DxDropDownButton
            :items="buttonData"
            class="export-dropdown"
            :text="$t('common.grid.export')"
            @item-click="onItemClick"
          />
        </template>
        <template #columnButtonTemplate>
          <button class="custom-columns" @click="dataGrid.showColumnChooser()">
            <span class="custom-text">{{ $t("common.grid.columns") }} </span>

            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>

        <template #status-cell="{ data }">
          <div
            class="text-700 custom-sizes"
            :class="{
              'text-blue': data.data.status == 'Draft',
              'text-success': data.data.status == 'Active',
              'text-danger':
                data.data.status == 'Active with errors' ||
                data.data.status == 'Active With Errors' ||
                data.data.status == 'Inactive' ||
                data.data.status == 'Authentication Failed' ||
                data.data.status == 'Authentication failed' ||
                data.data.status == 'Invalid',
            }"
          >
            {{ data.data.translatedStatus }}

            <svg
              v-if="data.value == 'Invalid'"
              tabindex="0"
              v-b-tooltip
              :id="data.data.id + 'int'"
              style="margin-inline-start: 10px; outline: none"
              width="17.73"
              height="17.73"
              viewBox="0 0 17.73 17.73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.86201 5.64211e-08C7.10912 0.000197833 5.39565 0.520172 3.93827 1.49417C2.48089 2.46817 1.34505 3.85245 0.674388 5.47197C0.00372177 7.09149 -0.171673 8.87351 0.170421 10.5927C0.512514 12.3119 1.35671 13.891 2.59626 15.1304C3.83582 16.3698 5.41506 17.2139 7.13429 17.5558C8.85351 17.8977 10.6355 17.7221 12.255 17.0512C13.8744 16.3804 15.2586 15.2444 16.2324 13.7869C17.2062 12.3294 17.726 10.6159 17.726 8.86299C17.726 7.699 17.4967 6.54641 17.0513 5.47104C16.6058 4.39567 15.9529 3.41857 15.1297 2.59555C14.3066 1.77253 13.3295 1.11971 12.254 0.674362C11.1786 0.229014 10.026 -0.000131275 8.86201 5.64211e-08ZM10.021 13.5C10.021 13.8074 9.89891 14.1022 9.68156 14.3195C9.4642 14.5369 9.1694 14.659 8.86201 14.659C8.55462 14.659 8.25982 14.5369 8.04246 14.3195C7.82511 14.1022 7.70301 13.8074 7.70301 13.5V8C7.70301 7.69261 7.82511 7.39781 8.04246 7.18045C8.25982 6.9631 8.55462 6.84099 8.86201 6.84099C9.1694 6.84099 9.4642 6.9631 9.68156 7.18045C9.89891 7.39781 10.021 7.69261 10.021 8V13.5ZM8.86201 5.388C8.63336 5.3874 8.41001 5.31913 8.2201 5.19179C8.0302 5.06445 7.88223 4.88374 7.79487 4.67244C7.70751 4.46114 7.68466 4.22871 7.7292 4.00444C7.77373 3.78017 7.88368 3.57412 8.04515 3.41223C8.20661 3.25035 8.41239 3.13987 8.63655 3.09476C8.8607 3.04964 9.09317 3.07191 9.3047 3.15872C9.51622 3.24554 9.69732 3.39302 9.82514 3.5826C9.95297 3.77217 10.0218 3.99536 10.023 4.224C10.0237 4.37674 9.9941 4.5281 9.93602 4.66937C9.87793 4.81064 9.79246 4.93902 9.68455 5.04712C9.57664 5.15522 9.4484 5.24091 9.30723 5.29924C9.16606 5.35757 9.01475 5.38739 8.86201 5.38699V5.388Z"
                fill="#ACACAC"
              />
            </svg>

            <b-tooltip
              placement="bottomright"
              :target="data.data.id + 'int'"
              triggers="click blur"
            >
              {{ data.data.invalidError }}
            </b-tooltip>
          </div>
        </template>

        <template #action-cell="{ data }">
          <Actions :integrationData="data.data" />
        </template>
      </DxDataGrid>
      
    </section>
  </div>
</template>
<script>
import moment from "moment";
import Actions from "@/components/integration/ActionsForIntegration";
import PageHeader from "@/components/page-header";
// import DataTable from "@/components/grid/DataTable";
import AddIntegModal from "@/components/integration/AddIntegModal";
import AddIntegModalExtraScenario from "@/components/integration/AddIntegModalExtraScenario";
import WondeHaveTokenModal from "@/components/integration/WondeHaveTokenModal";
import NoGroupsModal from "@/components/integration/NoGroupsModal";
import { mapActions, mapGetters } from "vuex";
const dataGridRefName = "dataGrid";
// import DxSelectBox from 'devextreme-vue/select-box';
import { default as Button } from "devextreme-vue/button";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import "whatwg-fetch";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
import { integrationColumns } from "@/utils/dataSource";
import amiriFont from "@/assets/fonts/Amiri-Regular.ttf"; // Load the Cairo font

import DxDataGrid, {
  // DxMasterDetail,
  DxColumn,
  // DxLookup,
  DxFilterRow,
  DxHeaderFilter,
  // DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxToolbar,
  DxItem,
  DxPaging,
  DxPager,
  DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxStateStoring,
} from "devextreme-vue/data-grid";
export default {
  title: "Integration",
  components: {
    // DxSelectBox,
    Actions,
    PageHeader,
    // DataTable,
    AddIntegModal,
    DxDataGrid,
    // DxMasterDetail,
    DxColumn,
    // DxLookup,
    DxFilterRow,
    DxHeaderFilter,
    DxPaging,
    DxPager,
    DxGrouping,
    DxGroupPanel,
    // DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxToolbar,
    DxItem,
    Button,
    DxDropDownButton,
    NoGroupsModal,
    AlertFoundActiveSession,
    WondeHaveTokenModal,
    AddIntegModalExtraScenario,
    DxScrolling,
    DxStateStoring,
  },
  data() {
    return {
      gridLoaded: false,
      rtlEnabled: false,
      buttonData: ["Excel", "CSV", "PDF"],
      showSubmenuModes: [
        {
          name: "onHover",
          delay: { show: 0, hide: 500 },
        },
        {
          name: "onClick",
          delay: { show: 0, hide: 300 },
        },
      ],
      title: this.$t("sideNavbarMenu.integration.text"),
      addIntegrationTitle: "Add integration",
      cards: [],
      dataGridRefName,
      allowedOperations: ["contains"],
      filterValue: [
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 6
        ),
        new Date(),
      ],
      showClearAll: false,
      integrationsArr : [],
    };
  },
  methods: {
    ...mapActions("modal", ["setData"]),
    ...mapActions("integration", [
      "fetchDirectoryList",
      "fetchGridIntegrationData",
      "resetIntgData",
      "setReAuth",
      "setIsExtraScenario",
    ]),
    ...mapActions("grid", [
      "createTableHeaders",
      "onTableHeader",
      "updateTableHeaders",
    ]),
    ...mapActions("grid", [
      "createTableHeaders",
      "onTableHeader",
      "updateTableHeaders",
    ]),

    setDataAndReAuth(data) {
      console.log("data", data);
      this.setData(data);
      this.setReAuth(false);
      this.setIsExtraScenario(false);
      if (data.code == "googleAD") {
        window.location.href = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?access_type=offline&prompt=select_account%20consent&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fadmin.directory.user.readonly%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fadmin.directory.group.readonly%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fadmin.directory.group.member.readonly%20https%3A%2F%2Fwww.googleapis.com/auth/userinfo.email&response_type=code&client_id=376633202470-sgcd4j8vp7b4sohe6fn3ake8k95t1lal.apps.googleusercontent.com&redirect_uri=${process.env.VUE_APP_REDIRECT_INTEGRATION_URL}/api/googleAD/token&flowName=GeneralOAuthFlow&state=${this.getDomain}`;
      }
    },

    async checkErrs(data) {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_INTEGRATION_URL}/api/integration/${data.id}/statistics`
        );
        console.log("resp", data.id, response);
        return data.status != "Expired" && response.errors;
      } catch (error) {
        console.log(error);
      }
    },

    getSites(rowData) {
      return rowData.sites.map((x) => x.name).join(" - ");
    },

    getStatus(rowData) {
      return rowData.translatedStatus;
    },

    actionChanged(action, data) {
      console.log(action, data);
    },

    onItemClick(e) {
      e.rtlEnabled = this.rtlEnabled;
      if (e.itemData == "Excel") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Integrations.xlsx"
            );
          });
        });
        // e.cancel = true;
      } else if (e.itemData == "CSV") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.csv.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Integrations.csv"
            );
          });
        });
      } else if (e.itemData == "PDF") {
        const doc = new jsPDF('landscape');
        
        // Add custom font
        doc.addFont(amiriFont, "Amiri", "normal");
        doc.setFont("Amiri");

        doc.autoTable({ direction: "rtl" });

        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: this.dataGrid,
          customizeCell: function (options) {
            const { gridCell, pdfCell } = options;

            if (gridCell.rowType === "data") {
              // data columns style
              pdfCell.styles = {
                font: e.rtlEnabled ? "Amiri" : "Lato",
                fontStyle: "normal",
                fontSize: 8,
                cellWidth: "auto",
                halign: "center",
              };
            } else {
              // header columns style
              pdfCell.styles = {
                font: e.rtlEnabled ? "Amiri" : "Lato",
                fontStyle: "normal",
                fontSize: 8,
                fillColor: "#2680EB",
                textColor: "#FFFFFF",
                cellWidth: "auto",
                halign: "center", 
              };
            }
          },
          customizeTable: (doc) => {
            doc.autoTable({ direction: "rtl" }); // Ensure table follows RTL direction
          },
        }).then(() => {
          const pageCount = doc.internal.getNumberOfPages();
          for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            const pageSize = doc.internal.pageSize;
            const pageWidth = pageSize.width
              ? pageSize.width
              : pageSize.getWidth();
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            const header = this.$t('integrations.addIntegration');
            const headerWidth = doc.getTextDimensions(header).w;
            const footer = `${this.$t("common.page")} ${i} ${this.$t("common.of")} ${pageCount}`;

            // Header
            doc.text(header, (pageWidth - headerWidth) / 2, 10);

            // Footer
            doc.text(
              footer,
              pageWidth / 2 - doc.getTextWidth(footer) / 2,
              pageHeight - 5,
              { baseline: "bottom" }
            );
          }

          doc.save("Integrations.pdf");
        });
      }
    },

    clearFilter() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },
    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      console.log("e", filterExp, sortedExp);
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },
    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },
    setColumnChooserPosition() {
      // this.dataGrid.showColumnChooser();
      // console.log("columnChooserView");

      var columnChooserView = this.dataGrid.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.rtlEnabled ? "right top" : "left top",
        at: this.rtlEnabled ? "right top" : "left top",
        offset: "0 50",
      });
    },
    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },
    fetchTableHeaders() {
      this.onTableHeader({
        url: "/integrations",
        headers: integrationColumns,
      });
    },
    async customLoad() {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        await this.onTableHeader({
          url: "/integrations",
        });
        let value = this.getTableHeaders;
        if (value) {
          // value = JSON.parse(value);
          // value.searchText = '';
          value.pageIndex = 0;
          value.pageSize = 50;
          for (let i = 0; i < value.columns.length; i++) {
            if (value.columns[i].dataField == "errors") {
              value.columns[i].visibleIndex = 3;
            } else if (value.columns[i].dataField == "duplicates") {
              value.columns[i].visibleIndex = 3;
            }
          }
        }
        return value;
      }
    },
    customSave(gridState) {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        gridState.pageIndex = 0;
        gridState.pageSize = 50;
        let value = JSON.stringify(gridState);
        value = value.replace(',"selectedRowKeys":[]', "");
        if (!this.getTableHeaders) {
          this.createTableHeaders({
            url: "/integrations",
            headers: value,
            filters: "[]",
          });
        } else if (value != JSON.stringify(this.getTableHeaders)) {
          this.updateTableHeaders({
            url: "/integrations",
            headers: value,
            filters: "[]",
          });
        }
        console.log(
          "customSave values",
          value != JSON.stringify(this.getTableHeaders)
        );
      }
    },
    onDataErrorOccurred(e) {
      console.log("onDataErrorOccurred e", e);
      setTimeout(() => {
        let errorRow = document.querySelector(
          ".dx-datagrid-headers .dx-error-message"
        );
        errorRow.innerHTML = this.$t("common.notes.anErrorOccurredGrid");
      }, 100);
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("integration", [
      "getDirectoryList",
      "getGridIntegrationData",
      "getNoGroups",
    ]),
    ...mapGetters("grid", ["getTableHeaders", "getSelectedRows", "getLoading"]),
    ...mapGetters("authfack", ["userDetails"]),
    getDomain() {
      const parsedUrl = new URL(window.location.href);
      let domain = parsedUrl.hostname;
      if (domain.startsWith("www.")) {
        domain = domain.slice(4); // Remove leading "www."
      }
      return domain;
    },
    getDataCount() {
      console.log("count");
      return false;
    },
    rowsData() {
      // this.dataGrid.beginCustomLoading();
      console.log("rowsada", this.getGridIntegrationData);
      return this.getGridIntegrationData &&
        this.getGridIntegrationData.length > 0
        ? this.getGridIntegrationData.map((el) => {
            return {
              integrationName: el.name,
              integrationType: el.directory ? el.directory.code : el.dir_code,
              type: el.directory ? el.directory.name : el.dir_code,
              status:
                el.status && el.status.toLowerCase() == "active with errors"
                  ? "Active"
                  : el.status,
                translatedStatus: this.$t(`integrations.${el.status.toLowerCase()}`),
              errors:
                el.errors_counter > 0 && el.status !== "Draft"
                  ? el.errors_counter
                  : "-",
              duplicates:
                el.duplicates_counter > 0 && el.status !== "Draft"
                  ? el.duplicates_counter
                  : "-",
              syncPeriod: el.sync_setting
                ? el.sync_setting.sync_time == 1
                  ? this.$t("integrations.daily")
                  : el.sync_setting.sync_time == 2
                  ? this.$t("integrations.weekly")
                  : el.sync_setting.sync_time == 3
                  ? this.$t("integrations.monthly")
                  : el.sync_setting.sync_time == 4
                  ? this.$t("integrations.immediately")
                  : ""
                : "",
              creationDate: 
              this.getLanguage === "ar" ?
              moment(new Date(el.created_at)).locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm:ss") + 
          (moment(new Date(el.created_at)).format("A") === "AM" ? " ص" : " م")
          : moment(new Date(el.created_at)).format("DD/MM/YYYY - h:mm:ss A"),
              lastSynced: el.last_sync
                ? 
                this.getLanguage === "ar" ?
              moment(new Date(el.last_sync)).locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm:ss") + 
          (moment(new Date(el.last_sync)).format("A") === "AM" ? " ص" : " م")
          : moment(new Date(el.last_sync)).format("DD/MM/YYYY - h:mm:ss A") : "",
              createdBy: el.created_by
                ? el.created_by.email == "lt_techteam@visipoint.com"
                  ? "Admin - CS"
                  : el.created_by.fullName
                : "",
              sites: el.sites,
              showErrors: el.showErrors,
              showDuplicates: el.showDuplicates,
              showWriteBack: el.showWriteBack,
              invalidError: el.invalidError,
              show_action: el.show_action,
              show_remove: el.deletable,
              id: el.id,
            };

          })
        : [];
    },
    dataGrid() {
      return this.$refs[this.dataGridRefName].instance;
    },
    userEmail() {
      return this.userDetails && this.userDetails.email;
    },
  },
  async beforeMount() {
    setTimeout(() => {
      this.dataGrid.beginCustomLoading();
    },100)
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
    this.fetchDirectoryList();
    this.fetchGridIntegrationData().then((data) => {
      this.integrationsArr =  data && data.length > 0
        ? data.map((el) => {
            return {
              integrationName: el.name,
              integrationType: el.directory ? el.directory.code : el.dir_code,
              type: el.directory ? el.directory.name : el.dir_code,
              status:
                el.status && el.status.toLowerCase() == "active with errors"
                  ? "Active"
                  : el.status,
                translatedStatus: this.$t(`integrations.${el.status.toLowerCase()}`),
              errors:
                el.errors_counter > 0 && el.status !== "Draft"
                  ? el.errors_counter
                  : "-",
              duplicates:
                el.duplicates_counter > 0 && el.status !== "Draft"
                  ? el.duplicates_counter
                  : "-",
              syncPeriod: el.sync_setting
                ? el.sync_setting.sync_time == 1
                  ? this.$t("integrations.daily")
                  : el.sync_setting.sync_time == 2
                  ? this.$t("integrations.weekly")
                  : el.sync_setting.sync_time == 3
                  ? this.$t("integrations.monthly")
                  : el.sync_setting.sync_time == 4
                  ? this.$t("integrations.immediately")
                  : ""
                : "",
              creationDate: 
              this.getLanguage === "ar" ?
              moment(new Date(el.created_at)).locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm:ss") + 
          (moment(new Date(el.created_at)).format("A") === "AM" ? " ص" : " م")
          : moment(new Date(el.created_at)).format("DD/MM/YYYY - h:mm:ss A"),
              lastSynced: el.last_sync
                ? 
                this.getLanguage === "ar" ?
              moment(new Date(el.last_sync)).locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm:ss") + 
          (moment(new Date(el.last_sync)).format("A") === "AM" ? " ص" : " م")
          : moment(new Date(el.last_sync)).format("DD/MM/YYYY - h:mm:ss A") : "",
              createdBy: el.created_by
                ? el.created_by.email == "lt_techteam@visipoint.com"
                  ? "Admin - CS"
                  : el.created_by.fullName
                : "",
              sites: el.sites,
              showErrors: el.showErrors,
              showDuplicates: el.showDuplicates,
              showWriteBack: el.showWriteBack,
              invalidError: el.invalidError,
              show_action: el.show_action,
              show_remove: el.deletable,
              id: el.id,
            };

          })
        : [];

      this.dataGrid.endCustomLoading();
    });
    this.resetIntgData();
    console.log(this.getDirectoryList);
  },
  watch: {
    getNoGroups(state) {
      state && this.$bvModal.hide("addIntegration");
      state && this.$bvModal.show("noGroups");
    },
    getGridIntegrationData(data) {
      console.log('getGridIntegrationData', data);
      if (this.getGridIntegrationData) this.gridLoaded = true;
    }
  },
  created() {
    document.addEventListener("mousedown", (e) => {
      if (e.path) {
        let isColumnChooser = false;
        for (let i = 0; i < e.path.length; i++) {
          if (typeof e.path[i].matches == "function") {
            if (e.path[i].matches(".dx-overlay-content")) {
              isColumnChooser = true;
            }
          }
        }
        if (!isColumnChooser) this.dataGrid.hideColumnChooser();
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.main-page-container {
  height: calc(100vh - 146px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding-inline-end: 12px;
}
.main-page-container::-webkit-scrollbar {
  width: 11px;
  height: 11px;
}

.main-page-container::-webkit-scrollbar-thumb {
  background-color: #787878;
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: content-box;
}

.main-page-container::-webkit-scrollbar-thumb:hover {
  border: 0 solid transparent;
}
.main-page-container::-webkit-scrollbar-track {
  background-color: #d1d1d1;
  border-radius: 8px;
}
.card {
  margin-bottom: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-inline-start: 0px !important;
  width: 566px;
  height: 138px;
}

.card-body {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
}

.card-icon {
  padding-inline-end: 0 !important;
  padding-inline-start: 0 !important;
  display: flex;
  justify-content: center;
}

.card-circle {
  cursor: pointer !important;
}

.int-cards {
  .card-head {
    font-weight: 700;
    font-size: 18px;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #000000;
  }

  .card-text {
    font-weight: 500;
    font-size: 16px;
    line-height: 154%;
    color: rgba(0, 0, 0, 0.28);
  }
}

.img-customization {
  width: 67px;
  height: 67px;

  & img {
    height: 67px !important;
  }
}

.table-extension {
  width: 100% !important;
  height: 120px !important;
  background: white !important;
  text-align: center !important;

  // padding-top:84px!important;
  h4.no-int {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #495057;
    padding-bottom: 22px;
  }
}

.custom-sizes {
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 19px !important;

  .text-danger {
    color: #f46a6a !important;
  }

  .text-success {
    color: #34c38f;
  }

  .text-blue {
    color: #2680eb !important;
  }
}

// .header-close-style {
//   width: 22px;
//   height: 22px;
//   border-radius: 50%;
//   justify-content: center;
//   justify-items: center;
//   inset-inline-start: 70.21%;
//   inset-inline-end: 28.26%;
//   top: 33.67%;
//   bottom: 63.89%;

//   background: #f46a6a !important;
// }

.header-close:active {
  outline: none;
}

.text-700 {
  font-weight: 700;
}

.text-blue {
  color: #2680eb;
}

h4 {
  font-weight: bold;
  color: black;
}

h5.int-grid {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  // margin-inline-start:30px;
  margin-bottom: 0 !important;
  color: #495057;
}

p {
  font-size: 12px;
  color: #b9b7b7;
}

.last_sync {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 0px;
  color: #c7c7c7;
}

img {
  height: 42px;
}

.mdi-plus-circle {
  font-size: 24px;
  color: #103f5e;
}

.white-bg-sec {
  background-color: white;
  padding-inline-start: 30px;
  padding-top: 32px;
}

.grid-wrapper.border {
  border: 0px !important;
}

.table thead th {
  color: #939393;
  background-color: #f8f9fa;
  border-radius: 5px;
  border-bottom: 0px;
}

.modal-content .modal-body {
  padding: 40px 82px 20px;
}

.modal-content {
  overflow: scroll !important;
}

.table th,
.table td {
  border-top: 0px;
  border-radius: 5px;
}

.table-style {
  width: 100% !important;
}

.header-close {
  color: #f2f2f2;
  font-weight: bold !important;
  background-color: transparent;
  border: none;
}

.header-close:active {
  outline: none;
}

h5.modal-title {
  width: 100%;

  font-weight: 700 !important;
  font-size: 20px !important;
  line-height: 20px !important;
  text-align: center !important;
  letter-spacing: 0.25px !important;
  color: #000000 !important;
}
</style>
<style lang="scss">
div#wondeFlow {
  div#wondeFlow___BV_modal_content_ {
    width: 579px;
    margin-top: 100px;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 26px;
    div#wondeFlow___BV_modal_body_ {
      .custom-radio .custom-control-label::before {
        border-radius: 50%;
        background-color: #c7c7c7 !important;
        width: 1.25rem !important;
        height: 1.25rem !important;
        border: 2.5px solid #c7c7c7 !important;
        top: 0.3125rem !important;
      }

      .custom-radio .custom-control-input:checked ~ .custom-control-label span {

        font-weight: 700 !important;
        color: #103f5e !important;
        //opacity: .8!important;
        padding-inline-start: toRem(10) !important;
      }
      .custom-radio .custom-control-input ~ .custom-control-label span {

        font-weight: 400 !important;
        color: #000 !important;

        padding-inline-start: toRem(10) !important;
      }

      .custom-radio .custom-control-label span {
        padding-inline-start: 10px !important;
      }

      .custom-radio .custom-control-label span {
        padding-inline-start: 10px !important;
      }

      .custom-radio
        .custom-control-input:checked
        ~ .custom-control-label::after {
        background-image: none !important;
        background-color: #103f5e !important;
        border-radius: 100% !important;
        width: 0.75rem !important;
        height: 0.75rem !important;
        top: 0.565rem !important;
        inset-inline-start: -1.25rem !important;
      }
    }
    .custom-activeRadio .custom-radio .custom-control-label span {
      padding-inline-start: 10px !important;
    }
    p.wonde-new-integration {

      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      margin-bottom: 40px;
      text-align: center;
      color: #000000;
    }
    h5.school-token {

      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      // margin-inline-start: 10px;
      margin-bottom: 30px;
      letter-spacing: 0.25px;

      color: #787878;
    }
    .custom-control.custom-control-inline.custom-radio:first-child {
      margin-inline-end: 28px;
    }
  }
}

.integration-table {
  tbody {
    color: #495057;
  }

  .dx-datagrid .dx-row > td {
    font-weight: 400;
    font-size: 16px !important;
    line-height: 19px !important;
  }
}

.no-content {
  .dx-scrollable-scroll-content {
    display: none !important;
  }
}

div#allIntgContainer {
  min-height: 500px !important;
}

.custom-ActionDropDown {
  ul.dropdown-menu.show {
    li.red-remove a {
      color: #f46a6a !important;
      padding-bottom: 10px !important;
    }

    align-items: center !important;
    background: #ffffff !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 6px !important;
    text-align: center !important;
    min-width: 142px !important;
    max-height: 179px !important;
    margin-top: 6px !important;
    overflow-y: scroll;
  }

  a.dropdown-item {
    margin: auto !important;

    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    text-align: center !important;
    color: #787878 !important;
    padding-inline-end: 24px !important;
  }

  .dropdown-menu.show::-webkit-scrollbar {
    width: 9px;
  }

  .dropdown-menu.show::-webkit-scrollbar-track {
    background: #ededed;
    height: 129px;
    border-radius: 8.5px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  .dropdown-menu.show::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
    height: 82px;
  }
}

.dropdown-menu.show::-webkit-scrollbar {
  width: 5px;

  .dropdown-menu.show::-webkit-scrollbar-track {
    background: #787878;
    border-radius: 0px 0px 10px 0px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  .dropdown-menu.show::-webkit-scrollbar-thumb {
    background: #34c38f;
    border-radius: 10px;
  }
}

.integration-white-bg-sec {
  background-color: white;
  padding-inline-start: 0px;
  padding-top: 25px;
  padding-bottom: 25px;
  //-overflow: hidden;
  border-radius: 8px !important;
}
@import "../../../assets/css/modal.scss";
</style>
